// Shared project colour palette + swatch picker, used by Settings and the
// sidebar's add-project form so both offer the same colours.
export const PROJECT_COLORS = [
  "#7C96FF",
  "#B78CFF",
  "#5AC8FA",
  "#43E0A0",
  "#FFB454",
  "#FF6B81",
  "#5DCAA5",
  "#F0997B",
];

export function ColorSwatches({
  value,
  onPick,
}: {
  value: string;
  onPick: (color: string) => void;
}) {
  return (
    <div className="pcolor-row">
      {PROJECT_COLORS.map((c) => (
        <button
          key={c}
          type="button"
          className={`pcolor-sw${c.toLowerCase() === value.toLowerCase() ? " on" : ""}`}
          style={{ background: c }}
          onClick={() => onPick(c)}
          aria-label={`Colour ${c}`}
        />
      ))}
    </div>
  );
}
